import { useEffect, useState } from 'react'
import { Column } from 'src/shared/components/Semantic/all'
import { Progress } from 'src/shared/components/ui/progress'
import { cn } from 'src/shared/components/ui/utils'

const MOCKUP_GENERATION_DURATION_MS = 15000
const PROGRESS_UPDATE_INTERVAL_MS = 100
const PROGRESS_CAP = 95

export const MockupGeneratingOverlay = ({
  loadingText,
  compact = false,
  className,
}: {
  loadingText: string
  compact?: boolean
  className?: string
}) => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const startTime = Date.now()

    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime
      const newProgress = Math.min(
        PROGRESS_CAP,
        (elapsed / MOCKUP_GENERATION_DURATION_MS) * PROGRESS_CAP
      )
      setProgress(newProgress)
    }, PROGRESS_UPDATE_INTERVAL_MS)

    return () => clearInterval(interval)
  }, [])

  return (
    <Column
      className={cn(
        'absolute inset-0 z-20 items-center justify-center bg-white/90',
        compact ? 'gap-2 p-2' : 'gap-4 p-6',
        className
      )}
    >
      <Column className={cn('items-center gap-2', compact ? 'w-full' : 'w-80')}>
        <Progress value={progress} className="w-full" />
        <p className={cn('text-muted-foreground', compact ? 'text-[10px]' : 'text-sm')}>
          {loadingText}
        </p>
      </Column>
    </Column>
  )
}
